import React from 'react';
import LzMCrud from '@lz/models/crud/Crud';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';

const config = new LzMCrud({
    ident: 'users',
    baseRoute: '/system/users',
    fields: {
        name: { size: 100, type: 'string', required: true },
        email: { size: 100, type: 'string', required: true },
        wp: { size: 30, type: 'string', required: true },
        phone: { size: 20, type: 'string', required: false, default: '' },
        role_id: { type: 'reference', refTableName: 'roles', required: true },
        is_active: { type: 'boolean', default: true },
        avatar_media: { type: 'media', mediaCategory: 'avatars', mediaFileType: 'image', mediaContentType: 'image/*', mediaIsPrivate: true },
    },
    listingColumns: {
        avatar_media: { mediaParams: { isAvatar: true, altFieldName: 'name' } },
        name: { label: 'Name', sortable: true, alignment: 'left' },
        email: { label: 'Email', sortable: true, alignment: 'left', displayFunction: (val) => <a href={'mailto:' + val}>{val}</a> },
        phone: { label: 'Phone', sortable: true, alignment: 'left', displayFunction: (val) => <a href={'tel:' + val}>{val}</a> },
        role_id: { label: 'Role', sortable: true, alignment: 'left' },
    },
    listingActionIcons: {
        rights: {
            route: '/system/users/{recordId}/rights',
            title: 'Rights',
            icon: <PlaylistAddCheckIcon />,
            color: 'info',
            sortOrder: 1,
        },
    },
    addFormInputs: {
        name: { label: 'Name' },
        email: { label: 'Email as Username', type: 'email' },
        wp: { label: 'Password', type: 'password' },
        phone: { label: 'Phone Number' },
        role_id: { label: 'User Role' },
        is_active: { label: 'Active', type: 'switch' },
        avatar_media: { label: 'Avatar', mediaParams: { isAvatar: true, altFieldName: 'name' } },
    },
    viewFormFields: {
        name: { label: 'Name' },
        email: { label: 'Email as Username', type: 'email' },
        wp: { label: 'Password', displayFunction: () => '********' },
        phone: { label: 'Phone Number' },
        role_id: { label: 'User Role' },
        is_active: { label: 'Active', displayFunction: (val) => !!val ? 'Active' : 'In-Active' },
        avatar_media: { label: 'Avatar', mediaParams: { isAvatar: true, altFieldName: 'name' } },
    },
    editFormInputs: {
        name: { label: 'Name' },
        email: { label: 'Email as Username', type: 'email' },
        wp: { label: 'Change Password', hintText: 'Only enter if want to change', type: 'password', required: false },
        phone: { label: 'Phone Number' },
        role_id: { label: 'User Role' },
        is_active: { label: 'Active', type: 'switch' },
        avatar_media: { label: 'Avatar', mediaParams: { isAvatar: true, altFieldName: 'name' } },
    },
});

export default config;
